var map = {
	"./Integracoes/2rsstore.png": 71876,
	"./Integracoes/Amazon_v2.png": 91199,
	"./Integracoes/Blau.png": 55966,
	"./Integracoes/Bling_v2.png": 66467,
	"./Integracoes/Digitalseller.png": 62337,
	"./Integracoes/Encomendador.png": 18905,
	"./Integracoes/FastcommerceLogo.png": 73984,
	"./Integracoes/GalaxCommerce.png": 4270,
	"./Integracoes/Hub2b.png": 92445,
	"./Integracoes/ISET.png": 42789,
	"./Integracoes/Ideris.png": 41228,
	"./Integracoes/Loja-integrada_v2.png": 81629,
	"./Integracoes/Lojas-Virtuais.png": 4889,
	"./Integracoes/Minestore.png": 78628,
	"./Integracoes/Nuvem-shop_v2.png": 93925,
	"./Integracoes/Opencart.png": 92684,
	"./Integracoes/Peras-loja.png": 57360,
	"./Integracoes/PrestaShop.png": 41201,
	"./Integracoes/Simplo7.png": 99456,
	"./Integracoes/WooCommerce.png": 22232,
	"./Integracoes/bagy.png": 54621,
	"./Integracoes/betalabs.png": 12484,
	"./Integracoes/box-loja.png": 62354,
	"./Integracoes/bwcommerce.png": 6970,
	"./Integracoes/cissa-marketplace.png": 43849,
	"./Integracoes/cws-logo.png": 30321,
	"./Integracoes/eCommerce-net.png": 10270,
	"./Integracoes/ebraun.png": 71769,
	"./Integracoes/getcommerce.png": 22505,
	"./Integracoes/irroba.png": 61017,
	"./Integracoes/logo-iluria-2020.png": 54857,
	"./Integracoes/loja2.png": 18290,
	"./Integracoes/lojaintegrada.png": 70637,
	"./Integracoes/lojameste.png": 37268,
	"./Integracoes/lojavirtual.png": 45865,
	"./Integracoes/novaoito.png": 65039,
	"./Integracoes/oruc.png": 12817,
	"./Integracoes/pagseguro.png": 22785,
	"./Integracoes/shoppingenuvem.png": 29468,
	"./Integracoes/terraEmpresas.png": 61066,
	"./Integracoes/tiny.png": 10696,
	"./Integracoes/tray.png": 72922,
	"./Integracoes/vendala.png": 19975,
	"./Integracoes/vendesk.png": 27404,
	"./Integracoes/visual-e-commerce.png": 23722,
	"./Integracoes/vtex.png": 41251,
	"./Integracoes/wbuy.png": 86995,
	"./Integracoes/webstore.png": 85835,
	"./Integracoes/wix.png": 9928,
	"./Integracoes/xTech.png": 50080,
	"./Integracoes/yampi.png": 37094,
	"./Transportadoras/Azul_Express_v2.png": 52255,
	"./Transportadoras/Azul_Express_v2.svg": 80528,
	"./Transportadoras/Correios_v2.png": 61304,
	"./Transportadoras/Jadlog_v2.png": 11313,
	"./Transportadoras/Jet_v2.svg": 83286,
	"./Transportadoras/Latam_v2.png": 6133,
	"./Transportadoras/Latam_v2.svg": 24682,
	"./Transportadoras/Loggi_v2.svg": 62375,
	"./Transportadoras/buslog_logo.svg": 65468
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86714;